'use client';

import React from 'react';
import { type LayoutProps } from './layout.type';
import { Header, StartScreenWeb } from '@brahma/components';
import useLocale from '$hooks/use-locale';
import { ONBOARDING } from '$locale/constants';
import { START_SCREEN_ARRAY_LENGTH, START_SCREEN_IMAGE_URL } from '$modules/onboarding/constants/layout';
const LayoutWeb: React.FC<LayoutProps> = ({
  children
}) => {
  const {
    t
  } = useLocale(ONBOARDING);
  const headingArray = Array.from(Array(START_SCREEN_ARRAY_LENGTH)).map((_, index) => t(`startScreen.partnerHeadingArray.${index}`));
  const textArray = Array.from(Array(START_SCREEN_ARRAY_LENGTH)).map((_, index) => t(`startScreen.partnerTextArray.${index}`));
  const imageArray = [`${START_SCREEN_IMAGE_URL}/partnerStartScreen1.png`, `${START_SCREEN_IMAGE_URL}/partnerStartScreen2.png`, `${START_SCREEN_IMAGE_URL}/partnerStartScreen3.png`];
  return <>
      <div style={{
      display: 'flex',
      margin: '-10px',
      height: '100%'
    }}>
        <div style={{
        width: '50%',
        position: 'relative'
      }}>
          <Header type="partner" data-sentry-element="Header" data-sentry-source-file="layout.web.tsx" />
          <StartScreenWeb textArray={textArray} headingArray={headingArray} imageArray={imageArray} background="gridCheckSmMobile" data-sentry-element="StartScreenWeb" data-sentry-source-file="layout.web.tsx" />
        </div>
        <div style={{
        width: '50%',
        margin: 'auto',
        height: '100%'
      }}>
          {children}
        </div>
      </div>
    </>;
};
export default LayoutWeb;